import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';

import LoaderButton from './LoaderButton';
import '../styles/Menu.css';
import { APP_ENVIRONMENT } from "../config/constants";
import { authSuccess, getCredentials } from "../actions";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.restoreCredentials = this.restoreCredentials.bind(this);
  }

  componentDidUpdate(prevProps) {
    if(this.props.authState.isAuthenticated && !prevProps.authState.isAuthenticated) {
      this.restoreCredentials();
    }
  }

  login() {
    this.props.authService.login('/');
  }

  logout() {
    this.props.authService.logout('/');
  }

  async restoreCredentials() {
    const { authService, dispatch } = this.props;
    dispatch(authSuccess());
    dispatch(getCredentials(await authService.getIdToken(), await authService.getUser()));
  }

  getAvailableLinks() {
    return (
      <ul className="nav navbar-nav">
        <li><NavLink exact activeStyle={{fontWeight: "bold"}} to="/">Home</NavLink></li>
        {this.props.isLoginComplete && this.props.alive && !this.props.newUser && this.props.applicationSet &&
        (this.props.complete ?
          (<li><NavLink to="/application" activeStyle={{fontWeight: "bold"}}>Applications</NavLink></li>)
          :
          (<li><NavLink to="/form" activeStyle={{fontWeight: "bold"}}>Form</NavLink></li>))
        }
      </ul>
    )
  }

  getUser() {
    if(this.props.isLoginComplete && this.props.userSet)
      return (
        <Navbar.Text pullRight>
          Hello, {this.props.newUser || (!this.props.user.complete && !this.props.user.updating) ? 'New User' : this.props.user.name.displayName}
        </Navbar.Text>
      );
    else
      return null;
  }

  getLoginOrLogout(){
    const AuthButton = (props) => {
      return (
        <Navbar.Form pullRight>
          <LoaderButton
            block
            isLoading={props.isLoading}
            text={props.text}
            glyph={props.glyph}
            loadingText={props.loadingText}
            onClick={props.onClick}
          />
        </Navbar.Form>
      )
    };
    if(this.props.isLoginComplete){
      return (
        <AuthButton
          onClick={this.logout}
          glyph="log-out"
          text="Log Out"
          loadingText="Logging Out..."
          isLoading={this.props.authService.isPending}/>
      )
    } else {
      return (
        <AuthButton
          onClick={this.login}
          glyph="log-in"
          text="Log In"
          loadingText="Logging In..."
          isLoading={this.props.authService.isPending}
          />
      )
    }
  }



  render() {
    const dev = APP_ENVIRONMENT === 'dev';
    const title = dev ? 'EOPS APPLICATIONS TEST ENVIRONMENT' : 'Delta EOPS Applications';
    return (
      <Navbar collapseOnSelect inverse={dev}>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">{title}</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          {this.getAvailableLinks()}
          {this.getLoginOrLogout()}
          {this.getUser()}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

function mapStateToProps(state) {
  const { application, appInfo, auth } = state;
  const { user, userSet, isLoginComplete } = auth;
  const { newUser, applicationSet } = appInfo;
  const { appOpenForStudents: alive } = appInfo.openTerm;
  const { complete } = application;
  return {
    isLoginComplete,
    user,
    userSet,
    newUser,
    alive,
    complete,
    applicationSet
  }
}

export default connect(mapStateToProps)(withOktaAuth(Menu));